<template>
  <v-btn
    :disabled="disabled"
    @click="$emit('onClicked')"
    :color="buttonColor ? buttonColor : null"
    :outline="depressed"
    :depressed="depressed"
  >
    <template v-if="!isLoading">
      <v-icon v-if="icon" :color="iconColor" class="mr-2">{{ icon }}</v-icon>
      <div class="text-none --text">{{ text }}</div>
    </template>
    <template v-else>
      <v-progress-circular indeterminate></v-progress-circular>
    </template>
  </v-btn>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    icon: {
      type: String,
    },
    buttonColor: {
      type: String,
      required: false,
    },
    depressed: {
      type: Boolean,
      default: false,
    },
    iconColor: {
      type: String,
      required: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),
  computed: {},
}
</script>
